
import {serializable, alias, object, list, primitive} from 'serializr';

export class RawMaterialPackagingMeta { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('activity_label', primitive()))
	label?: string;
	
	@serializable(alias('activity_label', primitive()))
	value?: string;

}